export const siteTitle = 'Summer Health';
export const siteDescription = `Connections to better. With a simple text message, get answers from our expert, board-certified pediatricians in 60 minutes. Any time, day or night.`;
